import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'hchartstock',
    template: `
    <div class="card p-0 p-md-3">
        <chart class="d-block" type="StockChart" [options]="options" (load)="saveInstance($event.context)"></chart>
    </div>`,
    styles: [`
    .highcharts-credits {
        display: none;
    }`],
    encapsulation: ViewEncapsulation.None
})

export class HChartstockComponent {

    @Input() public series: Array<Object>;
    @Input() public categories: Array<String>;
    @Input() public title: string;
    @Input() public type: string;
    @Input() public options: Object;
    chart: any;

    ngAfterViewInit() {
        if (!this.options)
            this.options = {
                chart: {
                    type: this.type
                },
                legend: {
                    align: "center",
                    verticalAlign: "bottom"
                },
                plotOptions: {
                    column: {
                        stacking: 'normal'
                    }
                },
                title: {
                    align: "left",
                    text: this.title,
                    style: { color: "#1B517F", fontWeight: "bold", fontSize: "2rem", marginBottom: ".5rem" }
                },
                xAxis: {
                    categories: this.categories,
                    labels: {
                        align: "right",
                        rotation: -45,
                        style: { color: "#1B517F" }
                    },
                    lineColor: "#1B517F",
                    tickColor: "#1B517F"
                },
                yAxis: {
                    labels: {
                        style: { color: "#1B517F" }
                    },
                    gridLineColor: "#1B517F",
                    stackLabels: {
                        enabled: true,
                        style: { color: "#1B517F" }
                    },
                    title: ""
                }
            };
    }

    saveInstance(chartInstance: any): void {
        this.chart = chartInstance;
    }
    ngOnChanges(changes: any) {
        this.updateTitle();
        this.updateSeries();
        this.updateCategories();
    }
    public updateTitle() {
        if (this.chart) {
            this.chart.setTitle({
                align: "left",
                text: this.title,
                style: { color: "#1B517F", fontWeight: "bold", fontSize: "2rem", marginBottom: ".5rem" }
            });
        }
    }
    public updateSeries() {
        if (this.chart) {
            while (this.chart.series.length > 0) {
                this.chart.series[0].remove(true);
            };
            this.series.forEach(element => {
                this.chart.addSeries(element);
            });
        }
    }
    public updateCategories() {
        if (this.chart) {
            this.chart.xAxis[0].setCategories(this.categories, true);
        }
    }

}